import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { FlameIcon, BookIcon, GiftIcon, UsersIcon, CertificateIcon, VideoIcon } from '../icons/SalesIcons';
export function FinalCTASection() {
  const includes = [{
    icon: BookIcon,
    text: 'Acceso inmediato a los 21 módulos'
  }, {
    icon: GiftIcon,
    text: '8 bonos adicionales incluidos'
  }, {
    icon: UsersIcon,
    text: 'Comunidad privada de apoyo'
  }, {
    icon: CertificateIcon,
    text: 'Certificado de finalización'
  }, {
    icon: VideoIcon,
    text: 'Videos de resolución de errores comunes'
  }];
  return <section className="bg-gradient-to-br from-[#2D2926] via-[#3D3936] to-[#2D2926] py-16 md:py-24" data-id="element-151">
      <div className="max-w-4xl mx-auto px-4" data-id="element-152">
        {/* Final Thought */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-153">
          <h2 className="font-heading text-3xl md:text-4xl text-white mb-8" data-id="element-154">
            Un Último Pensamiento Antes de Que Decidas
          </h2>

          <div className="space-y-6 text-lg text-[#D4A0A0] leading-relaxed max-w-2xl mx-auto" data-id="element-155">
            <p data-id="element-156">Hay dos versiones de ti en este momento.</p>

            <p data-id="element-157">
              La primera sigue guardando la cera en una caja, esperando "el
              momento correcto", viendo tutoriales sueltos que nunca terminan de
              enseñarle lo que necesita.
            </p>

            <p data-id="element-158">
              La segunda da un paso. Entra al curso. Sigue el sistema. Y en
              pocas semanas tiene frente a ella algo que hizo con sus manos — y
              que puede vender, regalar o simplemente disfrutar con orgullo.
            </p>

            <p className="text-xl font-bold text-white" data-id="element-159">
              La diferencia entre esas dos versiones eres tú. Y la decisión es
              ahora.
            </p>
          </div>
        </motion.div>

        {/* CTA Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} id="oferta-final" className="bg-gradient-to-br from-[#FDF8F4] to-[#FFFAF5] rounded-3xl p-8 md:p-12 text-center shadow-2xl" data-id="element-160">
          <h3 className="font-heading text-2xl md:text-3xl text-[#5C4033] mb-6" data-id="element-161">
            Da El Primer Paso
          </h3>

          {/* Pricing */}
          <div className="mb-6 flex flex-col items-center gap-2" data-id="element-162">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#9B2335] text-white text-sm font-bold rounded-full uppercase tracking-wide" data-id="element-163">
              25% de descuento — Oferta por tiempo limitado
            </div>
            <div className="flex items-baseline gap-3" data-id="element-164">
              <span className="text-xl text-[#5C4033]/40 line-through" data-id="element-165">
                $69 USD
              </span>
              <span className="font-heading text-5xl md:text-6xl text-[#9B2335] font-bold" data-id="element-166">
                $52.49 USD
              </span>
            </div>
            <p className="text-sm text-[#5C4033]/60" data-id="element-167">
              Pago único — Acceso de por vida a todo el contenido
            </p>
          </div>

          {/* CTA Button */}
          <div className="mb-8" data-id="element-168">
            <CTAButton text="Sí Quiero Encender Mi Llama — Quiero Acceder Ahora" size="lg" className="text-base md:text-lg" data-id="element-169" />
          </div>

          {/* What's Included */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-170">
            {includes.map((item, index) => <div key={index} className="flex items-center gap-3 justify-center md:justify-start" data-id="element-171">
                <item.icon size={20} className="text-[#9B2335]" data-id="element-172" />
                <span className="text-sm text-[#5C4033]" data-id="element-173">{item.text}</span>
              </div>)}
          </div>
        </motion.div>

        {/* Closing Quote */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center mt-12" data-id="element-174">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-175">
            <FlameIcon size={32} className="text-[#C4A882]" data-id="element-176" />
          </div>
          <p className="font-script text-2xl text-[#C4A882] mb-4" data-id="element-177">
            "Una vela no se enciende sola. Necesita una llama que la inicie.
            Deja que este curso sea esa llama."
          </p>
          <p className="text-[#D4A0A0]" data-id="element-178">
            — <strong className="text-white" data-id="element-179">Stefany Querubín</strong>,
            Instructora | ILUMINA Y CREA
          </p>
        </motion.div>
      </div>
    </section>;
}